/** Алфавит реф-кода: без похожих символов (0/o, 1/l/i). */
export const REF_CODE_ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';
export const REF_CODE_LENGTH = 8;

const REF_CODE_RE = new RegExp(`^[${REF_CODE_ALPHABET}]{${REF_CODE_LENGTH}}$`);
const SUB_ID_RE = /^[A-Za-z0-9_-]{1,40}$/;

/** Префикс реф-параметра в `/start` и `startapp`. */
export const REF_PREFIX = 'r_';

/** Криптостойкий код; работает и в Node, и в браузере (Web Crypto). */
export function generateRefCode(): string {
  const n = REF_CODE_ALPHABET.length;
  const limit = 256 - (256 % n); // отсечка, чтобы не было смещения по модулю
  let code = '';
  const buf = new Uint8Array(32);
  while (code.length < REF_CODE_LENGTH) {
    globalThis.crypto.getRandomValues(buf);
    for (const byte of buf) {
      if (byte < limit && code.length < REF_CODE_LENGTH) code += REF_CODE_ALPHABET[byte % n];
    }
  }
  return code;
}

export function isRefCode(value: string): boolean {
  return REF_CODE_RE.test(value);
}

export interface StartPayload {
  refCode: string;
  subId: string | null;
}

/**
 * Разбор параметра `/start <payload>` (бот) или `start_param` (мини-апп).
 * Формат: `r_<код>` или `r_<код>_<саб-айди>`. Всё остальное — null.
 */
export function parseStartPayload(payload: string | null | undefined): StartPayload | null {
  if (!payload) return null;
  const value = payload.trim();
  if (value.length > 64 || !value.startsWith(REF_PREFIX)) return null;

  const rest = value.slice(REF_PREFIX.length);
  const sep = rest.indexOf('_');
  const refCode = sep === -1 ? rest : rest.slice(0, sep);
  const subId = sep === -1 ? null : rest.slice(sep + 1);

  if (!isRefCode(refCode)) return null;
  if (subId !== null && !SUB_ID_RE.test(subId)) return null;
  return { refCode, subId };
}

export function buildStartPayload(refCode: string, subId?: string): string {
  return subId ? `${REF_PREFIX}${refCode}_${subId}` : `${REF_PREFIX}${refCode}`;
}
